export default {
    primary: '#4e4ee0',
    secondary: 'rgb(90,95,112)',
    tertiary: 'rgb(23, 27, 38)',
}
